__turbopack_context__.v({
  "button": "_7ViHrq_button",
  "container-grid": "_7ViHrq_container-grid",
  "text": "_7ViHrq_text",
});
